
import moment from 'moment';

export const KEY_ALL = 'all'

export const KEY_ACTIONLIST_INNING = 'inning'
export const KEY_ACTIONLIST_INNING_HALF = 'inning_half'
export const KEY_ACTIONLIST_ACTION_TYPE = 'action_type'
export const KEY_ACTIONLIST_ACTION_CODE = 'action_code'
export const KEY_ACTIONLIST_PLAYERNAME = 'player_name'
export const KEY_ACTIONLIST_RESULTCODE = 'result_code'

export const KEY_ACTIONLIST_PITCH_RESULTCODE = 'pitch_result_code'
export const KEY_ACTIONLIST_PITCH_TYPE = 'pitch_type'


export const KEY_ACTIONLIST_INNING_STRING = '以“局數”搜尋'
export const KEY_ACTIONLIST_TYPECODE_STRING = '以“Action Type/Code”搜尋'
export const KEY_ACTIONLIST_PITCHCODE_STRING = '以“Action Type/Code”搜尋'
export const KEY_ACTIONLIST_PLAYERNAME_STRING = '以球員名稱搜尋'
export const KEY_ACTIONLIST_RESULTCODE_STRING = '以成績代碼搜尋'

export const KEY_ACTIONLIST_PITCH_RESULTCODE_STRING = '以“Pitch Result”搜尋'

export const GAME_ACTIONLIST_INNING_HALF_TOP = 1
export const GAME_ACTIONLIST_INNING_HALF_BOTTOM = 2

export const GAME_ACTIONLIST_INNING_HALF_TOP_STRING = "上"
export const GAME_ACTIONLIST_INNING_HALF_BOTTOM_STRING = "下"

export const inning_half_arr = [
    { val: GAME_ACTIONLIST_INNING_HALF_TOP, name: GAME_ACTIONLIST_INNING_HALF_TOP_STRING },
    { val: GAME_ACTIONLIST_INNING_HALF_BOTTOM, name: GAME_ACTIONLIST_INNING_HALF_BOTTOM_STRING },
]

export function get_inning_half_string(ih) {
    if (ih === GAME_ACTIONLIST_INNING_HALF_TOP)
        return GAME_ACTIONLIST_INNING_HALF_TOP_STRING
    else if (ih === GAME_ACTIONLIST_INNING_HALF_BOTTOM)
        return GAME_ACTIONLIST_INNING_HALF_BOTTOM_STRING
    else
        return ""
}

export const GAME_ACTIONLIST_TYPE_PITCH = "Pitch"
export const GAME_ACTIONLIST_TYPE_NONBIP = "NONBIP"
export const GAME_ACTIONLIST_TYPE_MISC = "MISC"
export const GAME_ACTIONLIST_TYPE_PITCH_BEFORE = "Pitch-before"
export const GAME_ACTIONLIST_TYPE_PITCH_AFTER = "Pitch-after"
export const GAME_ACTIONLIST_TYPE_BASERUNNER = "BaseRunner"
export const GAME_ACTIONLIST_TYPE_ADBH = "AdvanceByHitter"
export const GAME_ACTIONLIST_TYPE_IPO = "In-Play-OUT"
export const GAME_ACTIONLIST_TYPE_IPS = "In-Play-Safe"
export const GAME_ACTIONLIST_TYPE_NACT = "Not-Act"


export const GAME_ACTIONLIST_TYPE_PITCH_CODE = "PI"
export const GAME_ACTIONLIST_TYPE_NONBIP_CODE = "NBP"
export const GAME_ACTIONLIST_TYPE_MISC_CODE = "MISC"
export const GAME_ACTIONLIST_TYPE_PITCH_BEFORE_CODE = "PB"
export const GAME_ACTIONLIST_TYPE_PITCH_AFTER_CODE = "PA"
export const GAME_ACTIONLIST_TYPE_BASERUNNER_CODE = "BR"
export const GAME_ACTIONLIST_TYPE_ADBH_CODE = "AdBH"
export const GAME_ACTIONLIST_TYPE_IPO_CODE = "IPO"
export const GAME_ACTIONLIST_TYPE_IPS_CODE = "IPS"
export const GAME_ACTIONLIST_TYPE_NACT_CODE = "NAct"

export function getActionTypeCode(type) {
    switch (type) {
        case GAME_ACTIONLIST_TYPE_PITCH:
            return GAME_ACTIONLIST_TYPE_PITCH_CODE
        case GAME_ACTIONLIST_TYPE_NONBIP:
            return GAME_ACTIONLIST_TYPE_NONBIP_CODE
        case GAME_ACTIONLIST_TYPE_MISC:
            return GAME_ACTIONLIST_TYPE_MISC_CODE
        case GAME_ACTIONLIST_TYPE_PITCH_BEFORE:
            return GAME_ACTIONLIST_TYPE_PITCH_BEFORE_CODE
        case GAME_ACTIONLIST_TYPE_PITCH_AFTER:
            return GAME_ACTIONLIST_TYPE_PITCH_AFTER_CODE
        case GAME_ACTIONLIST_TYPE_BASERUNNER:
            return GAME_ACTIONLIST_TYPE_BASERUNNER_CODE
        case GAME_ACTIONLIST_TYPE_ADBH:
            return GAME_ACTIONLIST_TYPE_ADBH_CODE
        case GAME_ACTIONLIST_TYPE_IPO:
            return GAME_ACTIONLIST_TYPE_IPO_CODE
        case GAME_ACTIONLIST_TYPE_IPS:
            return GAME_ACTIONLIST_TYPE_IPS_CODE
        case GAME_ACTIONLIST_TYPE_NACT:
            return GAME_ACTIONLIST_TYPE_NACT_CODE
        default:
            return ""
    }
}

export const GAME_ACTIONLIST_TYPE_PITCH_STRING = "Pitch"
export const GAME_ACTIONLIST_TYPE_NONBIP_STRING = "NONBIP"
export const GAME_ACTIONLIST_TYPE_MISC_STRING = "MISC"
export const GAME_ACTIONLIST_TYPE_PITCH_BEFORE_STRING = "Pitch-before"
export const GAME_ACTIONLIST_TYPE_PITCH_AFTER_STRING = "Pitch-after"
export const GAME_ACTIONLIST_TYPE_BASERUNNER_STRING = "BaseRunner"
export const GAME_ACTIONLIST_TYPE_ADBH_STRING = "AdvanceByHitter"
export const GAME_ACTIONLIST_TYPE_IPO_STRING = "In-Play-OUT"
export const GAME_ACTIONLIST_TYPE_IPS_STRING = "In-Play-Safe"
export const GAME_ACTIONLIST_TYPE_NACT_STRING = "Not-Act(NAct)"

export const GAME_ACTIONLIST = {
    PITCH: {
        Strk_C: { CODE: "Strk-C", STRING: "好球沒揮(Strk-C)" },
        Strk_S: { CODE: "Strk-S", STRING: "好球揮空(Strk-S)" },
        Foul: { CODE: "Foul", STRING: "界外球(Foul)" },
        Ball: { CODE: "Ball", STRING: "壞球(Ball)" },
        In_Play: { CODE: "In-Play", STRING: "打進場內(In-Play)" },
        Ball_Ill_Pi: { CODE: "Ball-Ill-Pi", STRING: "違規投球(Ball-Ill-Pi)" },
        Ball_B_I: { CODE: "Ball-B-I", STRING: "故意壞球(Ball-B-I)" },
    },
    NONBIP: {
        Ks: { CODE: "Ks", STRING: "三振出局-揮空(Ks)" },
        K: { CODE: "K", STRING: "三振出局-見逃(K)" },
        K_SF: { CODE: "K-SF", STRING: "擦棒被捕三振(K-SF)" },
        BB: { CODE: "BB", STRING: "保送上壘(BB)" },
        BB_I: { CODE: "BB-I", STRING: "故意壞球保送(BB-I)" },
        BB_IL: { CODE: "BB-IL", STRING: "違規投球保送(BB-IL)" },
        K_BS: { CODE: "K-BS", STRING: "觸擊落空(K-BS)" },
        K_DO: { CODE: "K-DO", STRING: "三好揮空落地(K-DO)" },
        K_DS: { CODE: "K-DS", STRING: "不死三振(K-DS)" },
        K_BF: { CODE: "K-BF", STRING: "觸擊界外三振(K-BF)" },
        HBP: { CODE: "HBP", STRING: "觸身球(HBP)" },
        IBB: { CODE: "IBB", STRING: "敬遠保送(IBB)" },
        OBC: { CODE: "OBC", STRING: "妨礙打擊(OBC)" },
    },
    MISC: {
        E_Foul: { CODE: "E-Foul", STRING: "E-界外漏接(E-Foul)" },
        Ill_Pi: { CODE: "Ill-Pi", STRING: "違規投球(Ill-Pi)" },
        B_I: { CODE: "B-I", STRING: "故意壞球(B-I)" },
        S_BF: { CODE: "S-BF", STRING: "觸擊界外(S-BF)" },
        S_BS: { CODE: "S-BS", STRING: "觸擊落空(S-BS)" },
        BK: { CODE: "BK", STRING: "投手犯規(BK)" },
        UN_P: { CODE: "UN-P", STRING: "投球-不明(UN-P)" },
    },
    PB: {
        PP: { CODE: "PP", STRING: "牽制(PP)" },
        PPO: { CODE: "PPO", STRING: "牽制出局(PPO)" },
        CS_PP: { CODE: "CS-PP", STRING: "牽制-盜壘失敗(CS-PP)" },
        SB_PP: { CODE: "SB-PP", STRING: "牽制-盜壘成功(SB-PP)" },
        E_TPP: { CODE: "E-TPP", STRING: "牽制-傳球失誤(E-TPP)" },
        E_CPP: { CODE: "E-CPP", STRING: "牽制-接球失誤(E-CPP)" },
        SB_PB: { CODE: "SB-PB", STRING: "盜壘(SB-PB)" },
        DI_PB: { CODE: "DI-PB", STRING: "忽略進壘(DI-PB)" },
        E_TOPB: { CODE: "E-TOPB", STRING: "球傳出界(E-TOPB)" },
        OBPB: { CODE: "OBPB", STRING: "妨礙跑壘(OBPB)" },
        OTO_PB: { CODE: "OTO-PB", STRING: "出局-其他(OTO-PB)" },
        OTS_PB: { CODE: "OTS-PB", STRING: "進壘-其他(OTS-PB)" },
    },
    PA: {
        CS_PA: { CODE: "CS-PA", STRING: "盜壘失敗(CS-PA)" },
        CPO: { CODE: "CPO", STRING: "捕手牽制出局(CPO)" },
        INT_PA: { CODE: "INT-PA", STRING: "妨礙守備(INT-PA)" },
        SB_PA: { CODE: "SB-PA", STRING: "盜壘(SB-PA)" },
        WP_PA: { CODE: "WP-PA", STRING: "暴投(WP-PA)" },
        PB_PA: { CODE: "PB-PA", STRING: "捕逸(PB-PA)" },
        DI_PA: { CODE: "DI-PA", STRING: "忽略進壘(DI-PA)" },
        E_TPA: { CODE: "E-TPA", STRING: "失誤進壘-傳球失誤(E-TPA)" },
        E_CPA: { CODE: "E-CPA", STRING: "失誤進壘-接球失誤(E-CPA)" },
        E_TOPA: { CODE: "E-TOPA", STRING: "球傳出界(E-TOPA)" },
        OBPA: { CODE: "OBPA", STRING: "妨礙跑壘(OBPA)" },
        OTO_PA: { CODE: "OTO-PA", STRING: "出局-其他(OTO-PA)" },
        OTS_PA: { CODE: "OTS-PA", STRING: "進壘-其他(OTS-PA)" },
    },
    BR: {
        RO01: { CODE: "RO01", STRING: "傳球封殺(RO01)" },
        RO02: { CODE: "RO02", STRING: "傳球觸殺(RO02)" },
        RO03: { CODE: "RO03", STRING: "自踩壘包(RO03)" },
        RO04: { CODE: "RO04", STRING: "觸殺(RO04)" },
        CS_BR: { CODE: "CS-BR", STRING: "盜壘失敗(CS-BR)" },
        RO05: { CODE: "RO05", STRING: "打到跑者(RO05)" },
        CPO_RS: { CODE: "CPO-RS", STRING: "捕手牽制出局(CPO-RS)" },
        RS01: { CODE: "RS01", STRING: "趁傳(RS01)" },
        E_TRS: { CODE: "E-TRS", STRING: "傳球失誤(E-TRS)" },
        E_CRS: { CODE: "E-CRS", STRING: "接球失誤(E-CRS)" },
        E_TORS: { CODE: "E-TORS", STRING: "球傳出界(E-TORS)" },
        SB_BR: { CODE: "SB-BR", STRING: "盜壘(SB-BR)" },
        WP_BR: { CODE: "WP-BR", STRING: "暴投(WP-BR)" },
        PB_BR: { CODE: "PB-BR", STRING: "捕逸(PB-BR)" },
        UN_RO: { CODE: "UN-RO", STRING: "出局-不明(UN-RO)" },
        UN_RS: { CODE: "UN-RS", STRING: "進壘-不明(UN-RS)" },
        RO11: { CODE: "RO11", STRING: "提前離壘(RO11)" },
        RO12: { CODE: "RO12", STRING: "超過三尺線(RO12)" },
        RO13: { CODE: "RO13", STRING: "漏踩壘包(RO13)" },
        RO14: { CODE: "RO14", STRING: "妨礙守備(RO14)" },
        RO15: { CODE: "RO15", STRING: "超過前面跑者(RO15)" },
        OT_RO: { CODE: "OT-RO", STRING: "特殊出局-其他(OT-RO)" },
        OBRS: { CODE: "OBRS", STRING: "妨礙跑壘(OBRS)" },
        E_TH: { CODE: "E-TH", STRING: "被球打到(E-TH)" },
        OT_RS: { CODE: "OT-RS", STRING: "特殊進壘-其他(OT-RS)" },
    },
    ADBH: {
        ABH: { CODE: "ABH", STRING: "打者推進(ABH)" },
    },
    IPO: {
        G: { CODE: "G", STRING: "刺殺(G)" },
        G_: { CODE: "G-", STRING: "自踩壘包(G-)" },
        GT: { CODE: "GT", STRING: "接球觸殺(GT)" },
        F: { CODE: "F", STRING: "接殺(F)" },
        SH: { CODE: "SH", STRING: "犧牲短打(SH)" },
        SF: { CODE: "SF", STRING: "犧牲飛球(SF)" },
        IF: { CODE: "IF", STRING: "內野飛球(IF)" },
        INT: { CODE: "INT", STRING: "妨礙守備(INT)" },
        LO: { CODE: "LO", STRING: "跑離三尺線(LO)" },
        OT_PO: { CODE: "OT-PO", STRING: "其他(OT-PO)" },
        UN_IO: { CODE: "UN-IO", STRING: "出局不明(UN-IO)" },
        DP: { CODE: "DP", STRING: "雙殺(DP)" },
        TP: { CODE: "TP", STRING: "三殺(TP)" },
    },
    IPS: {
        S1B: { CODE: "1B", STRING: "一壘安打(1B)" },
        S2B: { CODE: "2B", STRING: "二壘安打(2B)" },
        S3B: { CODE: "3B", STRING: "三壘安打(3B)" },
        HR: { CODE: "HR", STRING: "全壘打(HR)" },
        IHR: { CODE: "IHR", STRING: "場內全壘打(IHR)" },
        FOT: { CODE: "FOT", STRING: "趁傳上壘(FOT)" },
        E_C: { CODE: "E-C", STRING: "接球失誤(E-C)" },
        E_T: { CODE: "E-T", STRING: "傳球失誤(E-T)" },
        FC: { CODE: "FC", STRING: "野手選擇(FC)" },
        OBD: { CODE: "OBD", STRING: "妨礙跑壘(OBD)" },
        UN_IP: { CODE: "UN-IP", STRING: "上壘-不明(UN-IP)" },
        DP_S: { CODE: "DP-S", STRING: "雙殺上壘(DP-S)" },
        E_SF: { CODE: "E-SF", STRING: "犧飛失誤(E-SF)" },
    },
    NACT: {
        RBI: { CODE: "RBI", STRING: "打點(RBI)" },
        R: { CODE: "R", STRING: "失分(R)" },
        ER: { CODE: "ER", STRING: "責失分(ER)" },
    },
    PITCH_RESULT: {
        S_C: { CODE: "S-C", STRING: "好球沒揮(S-C)" },
        S_S: { CODE: "S-S", STRING: "好球揮空(S-S)" },
        S_FB: { CODE: "S-F", STRING: "界外球(S-F)" },
        Ball: { CODE: "Ball", STRING: "壞球(Ball)" },
        S_IP: { CODE: "S-IP", STRING: "打進場內(S-IP)" },
        Ill_Pi: { CODE: "Ill-Pi", STRING: "違規投球(Ill-Pi)" },
        B_I: { CODE: "B-I", STRING: "故意壞球(B-I)" },
    },
    PITCH_TYPE: {
        FB: { CODE: "FB", STRING: "速球(FB)" },
        FT: { CODE: "FT", STRING: "伸卡(FT)" },
        CT: { CODE: "CT", STRING: "卡特(CT)" },
        // FC: { CODE: "FC", STRING: "快速卡特(FC)" },
        SL: { CODE: "SL", STRING: "滑球(SL)" },
        CB: { CODE: "CB", STRING: "曲球(CB)" },
        // CT: { CODE: "CT", STRING: "慢速卡特(CT)" },
        CH: { CODE: "CH", STRING: "變速(CH)" },
        SP: { CODE: "SP", STRING: "指叉(SP)" },
        SFF: { CODE: "SFF", STRING: "快速指叉球(SFF)" },
        SC: { CODE: "SC", STRING: "慢速曲球(SC)" },
        KN: { CODE: "KN", STRING: "蝴蝶球(KN)" },
        OT: { CODE: "OT", STRING: "其他(OT)" },
        NO: { CODE: "?", STRING: "未知(?)" },
    }
}
// export const GAME_ACTIONLIST_CODE_PITCH_STRK_C = "Strk-C"
// export const GAME_ACTIONLIST_CODE_PITCH_STRK_S = "Strk-S"
// export const GAME_ACTIONLIST_CODE_PITCH_FOUL = "Foul"
// export const GAME_ACTIONLIST_CODE_PITCH_BALL = "Ball"
// export const GAME_ACTIONLIST_CODE_PITCH_INPLAY = "In-Play"
// export const GAME_ACTIONLIST_CODE_PITCH_BIP = "違規投球(Ball-Ill-Pi)"
// export const GAME_ACTIONLIST_CODE_PITCH_BBI = "Ball-B-I"
// export const GAME_ACTIONLIST_CODE_PITCH_STRK_C_STRING = "好球沒揮(Strk-C)"
// export const GAME_ACTIONLIST_CODE_PITCH_STRK_S_STRING = "好球揮空(Strk-S)"
// export const GAME_ACTIONLIST_CODE_PITCH_FOUL_STRING = "界外球(Foul)"
// export const GAME_ACTIONLIST_CODE_PITCH_BALL_STRING = "壞球(Ball)"
// export const GAME_ACTIONLIST_CODE_PITCH_INPLAY_STRING = "打進場內(In-Play)"
// export const GAME_ACTIONLIST_CODE_PITCH_BIP_STRING = "違規投球(Ball-Ill-Pi)"
// export const GAME_ACTIONLIST_CODE_PITCH_BBI_STRING = "故意壞球(Ball-B-I)"


// export const GAME_ACTIONLIST_CODE_NONBIP_KS = "Ks"
// export const GAME_ACTIONLIST_CODE_NONBIP_K = "K"
// export const GAME_ACTIONLIST_CODE_NONBIP_BB = "保送上壘(BB)"
// export const GAME_ACTIONLIST_CODE_NONBIP_BBI = "BB-I"
// export const GAME_ACTIONLIST_CODE_NONBIP_BBIL = "BB-IL"
// export const GAME_ACTIONLIST_CODE_NONBIP_KBS = "K-BS"
// export const GAME_ACTIONLIST_CODE_NONBIP_KDO = "K-DO"
// export const GAME_ACTIONLIST_CODE_NONBIP_KDS = "K-DS"
// export const GAME_ACTIONLIST_CODE_NONBIP_KFB = "K-FB"
// export const GAME_ACTIONLIST_CODE_NONBIP_HBP = "HBP"
// export const GAME_ACTIONLIST_CODE_NONBIP_IBB = "IBB"
// export const GAME_ACTIONLIST_CODE_NONBIP_KS_STRING = "三振出局-揮空(Ks)"
// export const GAME_ACTIONLIST_CODE_NONBIP_K_STRING = "三振出局-見逃(K)"
// export const GAME_ACTIONLIST_CODE_NONBIP_BB_STRING = "保送上壘(BB)"
// export const GAME_ACTIONLIST_CODE_NONBIP_BBI_STRING = "故意壞球保送(BB-I)"
// export const GAME_ACTIONLIST_CODE_NONBIP_BBIL_STRING = "違規投球保送(BB-IL)"
// export const GAME_ACTIONLIST_CODE_NONBIP_KBS_STRING = "觸擊落空(K-BS)"
// export const GAME_ACTIONLIST_CODE_NONBIP_KDO_STRING = "三好揮空落地(K-DO)"
// export const GAME_ACTIONLIST_CODE_NONBIP_KDS_STRING = "不死三振(K-DS)"
// export const GAME_ACTIONLIST_CODE_NONBIP_KFB_STRING = "觸擊界外三振(K-FB)"
// export const GAME_ACTIONLIST_CODE_NONBIP_HBP_STRING = "觸身球(HBP)"
// export const GAME_ACTIONLIST_CODE_NONBIP_IBB_STRING = "敬遠保送(IBB)"


// export const GAME_ACTIONLIST_CODE_MISC_EFOUL = "E-Foul"
// export const GAME_ACTIONLIST_CODE_MISC_ILLPI = "Ill-Pi"
// export const GAME_ACTIONLIST_CODE_MISC_BI = "B-I"
// export const GAME_ACTIONLIST_CODE_MISC_SFB = "S-FB"
// export const GAME_ACTIONLIST_CODE_MISC_SBS = "S-BS"
// export const GAME_ACTIONLIST_CODE_MISC_BK = "BK"
// export const GAME_ACTIONLIST_CODE_MISC_UNP = "UN-P"
// export const GAME_ACTIONLIST_CODE_MISC_EFOUL_STRING = "E-界外漏接(E-Foul)"
// export const GAME_ACTIONLIST_CODE_MISC_ILLPI_STRING = "違規投球(Ill-Pi)"
// export const GAME_ACTIONLIST_CODE_MISC_BI_STRING = "故意壞球(B-I)"
// export const GAME_ACTIONLIST_CODE_MISC_SFB_STRING = "觸擊界外(S-FB)"
// export const GAME_ACTIONLIST_CODE_MISC_SBS_STRING = "觸擊落空(S-BS)"
// export const GAME_ACTIONLIST_CODE_MISC_BK_STRING = "投手犯規(BK)"
// export const GAME_ACTIONLIST_CODE_MISC_UNP_STRING = "投球-不明(UN-P)"

// export const GAME_ACTIONLIST_CODE_PB_PP = "PP"
// export const GAME_ACTIONLIST_CODE_PB_PPO = "PPO"
// export const GAME_ACTIONLIST_CODE_PB_CS_PP = "CS-PP"
// export const GAME_ACTIONLIST_CODE_PB_SB_PP = "SB-PP"
// export const GAME_ACTIONLIST_CODE_PB_E_TPP = "E-TPP"
// export const GAME_ACTIONLIST_CODE_PB_E_CPP = "E-CPP"
// export const GAME_ACTIONLIST_CODE_PB_SB_PB = "SB-PB"
// export const GAME_ACTIONLIST_CODE_PB_DI_PB = "DI-PB"
// export const GAME_ACTIONLIST_CODE_PB_E_TOPB = "E-TOPB"
// export const GAME_ACTIONLIST_CODE_PB_OBPB = "OBPB"
// export const GAME_ACTIONLIST_CODE_PB_OTO_PB = "OTO-PB"
// export const GAME_ACTIONLIST_CODE_PB_OTS_PB = "OTS-PB"

// export const GAME_ACTIONLIST_CODE_PB_PP_STRING = "牽制(PP)"
// export const GAME_ACTIONLIST_CODE_PB_PPO_STRING = "牽制出局(PPO)"
// export const GAME_ACTIONLIST_CODE_PB_CS_PP_STRING = "牽制-盜壘失敗(CS-PP)"
// export const GAME_ACTIONLIST_CODE_PB_SB_PP_STRING = "牽制-盜壘成功(SB-PP)"
// export const GAME_ACTIONLIST_CODE_PB_E_TPP_STRING = "牽制-傳球失誤(E-TPP)"
// export const GAME_ACTIONLIST_CODE_PB_E_CPP_STRING = "牽制-接球失誤(E-CPP)"
// export const GAME_ACTIONLIST_CODE_PB_SB_PB_STRING = "盜壘(SB-PB)"
// export const GAME_ACTIONLIST_CODE_PB_DI_PB_STRING = "忽略進壘(DI-PB)"
// export const GAME_ACTIONLIST_CODE_PB_E_TOPB_STRING = "球傳出界(E-TOPB)"
// export const GAME_ACTIONLIST_CODE_PB_OBPB_STRING = "妨礙跑壘(OBPB)"
// export const GAME_ACTIONLIST_CODE_PB_OTO_PB_STRING = "出局-其他(OTO-PB)"
// export const GAME_ACTIONLIST_CODE_PB_OTS_PB_STRING = "進壘-其他(OTS-PB)"

// export const GAME_ACTIONLIST_CODE_PA_CS_PA = "CS-PA"
// export const GAME_ACTIONLIST_CODE_PA_CPO = "CPO"
// export const GAME_ACTIONLIST_CODE_PA_INT_PA = "INT-PA"
// export const GAME_ACTIONLIST_CODE_PA_SB_PA = "SB-PA"
// export const GAME_ACTIONLIST_CODE_PA_WP_PA = "WP-PA"
// export const GAME_ACTIONLIST_CODE_PA_PB_PA = "PB-PA"
// export const GAME_ACTIONLIST_CODE_PA_DI_PA = "DI-PA"
// export const GAME_ACTIONLIST_CODE_PA_E_TPA = "E-TPA"
// export const GAME_ACTIONLIST_CODE_PA_E_CPA = "E-CPA"
// export const GAME_ACTIONLIST_CODE_PA_E_TOPA = "E-TOPA"
// export const GAME_ACTIONLIST_CODE_PA_OBPA = "OBPA"
// export const GAME_ACTIONLIST_CODE_PA_OTO_PA = "OTO-PA"
// export const GAME_ACTIONLIST_CODE_PA_OTS_PA = "OTS-PA"

// export const GAME_ACTIONLIST_CODE_PA_CS_PA_STRING = "盜壘失敗(CS-PA)"
// export const GAME_ACTIONLIST_CODE_PA_CPO_STRING = "捕手牽制出局(CPO)"
// export const GAME_ACTIONLIST_CODE_PA_INT_PA_STRING = "妨礙守備(INT-PA)"
// export const GAME_ACTIONLIST_CODE_PA_SB_PA_STRING = "盜壘(SB-PA)"
// export const GAME_ACTIONLIST_CODE_PA_WP_PA_STRING = "暴投(WP-PA)"
// export const GAME_ACTIONLIST_CODE_PA_PB_PA_STRING = "捕逸(PB-PA)"
// export const GAME_ACTIONLIST_CODE_PA_DI_PA_STRING = "忽略進壘(DI-PA)"
// export const GAME_ACTIONLIST_CODE_PA_E_TPA_STRING = "失誤進壘-傳球失誤(E-TPA)"
// export const GAME_ACTIONLIST_CODE_PA_E_CPA_STRING = "失誤進壘-接球失誤(E-CPA)"
// export const GAME_ACTIONLIST_CODE_PA_E_TOPA_STRING = "球傳出界(E-TOPA)"
// export const GAME_ACTIONLIST_CODE_PA_OBPA_STRING = "妨礙跑壘(OBPA)"
// export const GAME_ACTIONLIST_CODE_PA_OTO_PA_STRING = "出局-其他(OTO-PA)"
// export const GAME_ACTIONLIST_CODE_PA_OTS_PA_STRING = "進壘-其他(OTS-PA)"

// export const GAME_ACTIONLIST_CODE_BR_RO01 = "RO01"
// export const GAME_ACTIONLIST_CODE_BR_RO02 = "RO02"
// export const GAME_ACTIONLIST_CODE_BR_RO03 = "RO03"
// export const GAME_ACTIONLIST_CODE_BR_RO04 = "RO04"
// export const GAME_ACTIONLIST_CODE_BR_CS_BR = "CS-BR"
// export const GAME_ACTIONLIST_CODE_BR_RO05 = "RO05"
// export const GAME_ACTIONLIST_CODE_BR_RS01 = "RS01"
// export const GAME_ACTIONLIST_CODE_BR_E_TRS = "E-TRS"
// export const GAME_ACTIONLIST_CODE_BR_E_CRS = "E-CRS"
// export const GAME_ACTIONLIST_CODE_BR_E_TORS = "E-TORS"
// export const GAME_ACTIONLIST_CODE_BR_SB_BR = "SB-BR"
// export const GAME_ACTIONLIST_CODE_BR_WP_BR = "WP-BR"
// export const GAME_ACTIONLIST_CODE_BR_PB_BR = "PB-BR"
// export const GAME_ACTIONLIST_CODE_BR_UN_RO = "UN-RO"
// export const GAME_ACTIONLIST_CODE_BR_UN_RS = "UN-RS"
// export const GAME_ACTIONLIST_CODE_BR_RO11 = "RO11"
// export const GAME_ACTIONLIST_CODE_BR_RO12 = "RO12"
// export const GAME_ACTIONLIST_CODE_BR_RO13 = "RO13"
// export const GAME_ACTIONLIST_CODE_BR_RO14 = "RO14"
// export const GAME_ACTIONLIST_CODE_BR_RO15 = "RO15"
// export const GAME_ACTIONLIST_CODE_BR_OT_RO = "OT-RO"
// export const GAME_ACTIONLIST_CODE_BR_OBRS = "OBRS"
// export const GAME_ACTIONLIST_CODE_BR_E_TH = "E-TH"
// export const GAME_ACTIONLIST_CODE_BR_OT_RS = "OT-RS"

// export const GAME_ACTIONLIST_CODE_BR_RO01_STRING = "傳球封殺(RO01)"
// export const GAME_ACTIONLIST_CODE_BR_RO02_STRING = "傳球觸殺(RO02)"
// export const GAME_ACTIONLIST_CODE_BR_RO03_STRING = "自踩壘包(RO03)"
// export const GAME_ACTIONLIST_CODE_BR_RO04_STRING = "觸殺(RO04)"
// export const GAME_ACTIONLIST_CODE_BR_CS_BR_STRING = "盜壘失敗(CS-BR)"
// export const GAME_ACTIONLIST_CODE_BR_RO05_STRING = "打到跑者(RO05)"
// export const GAME_ACTIONLIST_CODE_BR_RS01_STRING = "趁傳(RS01)"
// export const GAME_ACTIONLIST_CODE_BR_E_TRS_STRING = "傳球失誤(E-TRS)"
// export const GAME_ACTIONLIST_CODE_BR_E_CRS_STRING = "接球失誤(E-CRS)"
// export const GAME_ACTIONLIST_CODE_BR_E_TORS_STRING = "球傳出界(E-TORS)"
// export const GAME_ACTIONLIST_CODE_BR_SB_BR_STRING = "盜壘(SB-BR)"
// export const GAME_ACTIONLIST_CODE_BR_WP_BR_STRING = "暴投(WP-BR)"
// export const GAME_ACTIONLIST_CODE_BR_PB_BR_STRING = "捕逸(PB-BR)"
// export const GAME_ACTIONLIST_CODE_BR_UN_RO_STRING = "出局-不明(UN-RO)"
// export const GAME_ACTIONLIST_CODE_BR_UN_RS_STRING = "進壘-不明(UN-RS)"
// export const GAME_ACTIONLIST_CODE_BR_RO11_STRING = "提前離壘(RO11)"
// export const GAME_ACTIONLIST_CODE_BR_RO12_STRING = "超過三尺線(RO12)"
// export const GAME_ACTIONLIST_CODE_BR_RO13_STRING = "漏踩壘包(RO13)"
// export const GAME_ACTIONLIST_CODE_BR_RO14_STRING = "妨礙守備(RO14)"
// export const GAME_ACTIONLIST_CODE_BR_RO15_STRING = "超過前面跑者(RO15)"
// export const GAME_ACTIONLIST_CODE_BR_OT_RO_STRING = "特殊出局-其他(OT-RO)"
// export const GAME_ACTIONLIST_CODE_BR_OBRS_STRING = "妨礙跑壘(OBRS)"
// export const GAME_ACTIONLIST_CODE_BR_E_TH_STRING = "被球打到(E-TH)"
// export const GAME_ACTIONLIST_CODE_BR_OT_RS_STRING = "特殊進壘-其他(OT-RS)"

// export const GAME_ACTIONLIST_CODE_ADBH_AdBH = "AdBH"
// export const GAME_ACTIONLIST_CODE_ADBH_AdBH_STRING = "AdvanceByHitter(AdBH)"

// export const GAME_ACTIONLIST_CODE_IPO_G = "G"
// export const GAME_ACTIONLIST_CODE_IPO_G_ = "G-"
// export const GAME_ACTIONLIST_CODE_IPO_GT = "GT"
// export const GAME_ACTIONLIST_CODE_IPO_F = "F"
// export const GAME_ACTIONLIST_CODE_IPO_SH = "SH"
// export const GAME_ACTIONLIST_CODE_IPO_SF = "SF"
// export const GAME_ACTIONLIST_CODE_IPO_IF = "IF"
// export const GAME_ACTIONLIST_CODE_IPO_INT = "INT"
// export const GAME_ACTIONLIST_CODE_IPO_LO = "LO"
// export const GAME_ACTIONLIST_CODE_IPO_OT_PO = "OT-PO"
// export const GAME_ACTIONLIST_CODE_IPO_UN_IO = "UN-IO"
// export const GAME_ACTIONLIST_CODE_IPO_DP = "DP"
// export const GAME_ACTIONLIST_CODE_IPO_TP = "TP"

// export const GAME_ACTIONLIST_CODE_IPO_G_STRING = "刺殺(G)"
// export const GAME_ACTIONLIST_CODE_IPO_G__STRING = "自踩壘包(G-)"
// export const GAME_ACTIONLIST_CODE_IPO_GT_STRING = "接球觸殺(GT)"
// export const GAME_ACTIONLIST_CODE_IPO_F_STRING = "接殺(F)"
// export const GAME_ACTIONLIST_CODE_IPO_SH_STRING = "犧牲短打(SH)"
// export const GAME_ACTIONLIST_CODE_IPO_SF_STRING = "犧牲飛球(SF)"
// export const GAME_ACTIONLIST_CODE_IPO_IF_STRING = "內野飛球(IF)"
// export const GAME_ACTIONLIST_CODE_IPO_INT_STRING = "妨礙守備(INT)"
// export const GAME_ACTIONLIST_CODE_IPO_LO_STRING = "跑離三尺線(LO)"
// export const GAME_ACTIONLIST_CODE_IPO_OT_PO_STRING = "其他(OT-PO)"
// export const GAME_ACTIONLIST_CODE_IPO_UN_IO_STRING = "出局不明(UN-IO)"
// export const GAME_ACTIONLIST_CODE_IPO_DP_STRING = "雙殺(DP)"
// export const GAME_ACTIONLIST_CODE_IPO_TP_STRING = "三殺(TP)"

// export const GAME_ACTIONLIST_CODE_IPS_1B = "1B"
// export const GAME_ACTIONLIST_CODE_IPS_2B = "2B"
// export const GAME_ACTIONLIST_CODE_IPS_3B = "3B"
// export const GAME_ACTIONLIST_CODE_IPS_HR = "HR"
// export const GAME_ACTIONLIST_CODE_IPS_IHR = "IHR"
// export const GAME_ACTIONLIST_CODE_IPS_E_C = "E-C"
// export const GAME_ACTIONLIST_CODE_IPS_E_T = "E-T"
// export const GAME_ACTIONLIST_CODE_IPS_FC = "FC"
// export const GAME_ACTIONLIST_CODE_IPS_OBC = "OBC"
// export const GAME_ACTIONLIST_CODE_IPS_OBD = "OBD"
// export const GAME_ACTIONLIST_CODE_IPS_UN_IP = "UN-IP"
// export const GAME_ACTIONLIST_CODE_IPS_DP_S = "DP-S"

// export const GAME_ACTIONLIST_CODE_IPS_1B_STRING = "一壘安打(1B)"
// export const GAME_ACTIONLIST_CODE_IPS_2B_STRING = "二壘安打(2B)"
// export const GAME_ACTIONLIST_CODE_IPS_3B_STRING = "三壘安打(3B)"
// export const GAME_ACTIONLIST_CODE_IPS_HR_STRING = "全壘打(HR)"
// export const GAME_ACTIONLIST_CODE_IPS_IHR_STRING = "場內全壘打(IHR)"
// export const GAME_ACTIONLIST_CODE_IPS_E_C_STRING = "接球失誤(E-C)"
// export const GAME_ACTIONLIST_CODE_IPS_E_T_STRING = "傳球失誤(E-T)"
// export const GAME_ACTIONLIST_CODE_IPS_FC_STRING = "野手選擇(FC)"
// export const GAME_ACTIONLIST_CODE_IPS_OBC_STRING = "妨礙打擊(OBC)"
// export const GAME_ACTIONLIST_CODE_IPS_OBD_STRING = "妨礙跑壘(OBD)"
// export const GAME_ACTIONLIST_CODE_IPS_UN_IP_STRING = "上壘-不明(UN-IP)"
// export const GAME_ACTIONLIST_CODE_IPS_DP_S_STRING = "雙殺上壘(DP-S)"

// export const GAME_ACTIONLIST_CODE_NACT_RBI = "RBI"
// export const GAME_ACTIONLIST_CODE_NACT_R = "R"
// export const GAME_ACTIONLIST_CODE_NACT_ER = "ER"

// export const GAME_ACTIONLIST_CODE_NACT_RBI_STRING = "打點(RBI)"
// export const GAME_ACTIONLIST_CODE_NACT_R_STRING = "失分(R)"
// export const GAME_ACTIONLIST_CODE_NACT_ER_STRING = "責失分(ER)"

// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_C = "S-C"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_S = "S-S"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_FB = "S-FB"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_Ball = "Ball"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_IP = "S-IP"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_Ill_Pi = "Ill-Pi"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_B_I = "B-I"

// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_C_STRING = "好球沒揮(S-C)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_S_STRING = "好球揮空(S-S)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_FB_STRING = "界外球(S-FB)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_Ball_STRING = "壞球(Ball)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_IP_STRING = "打進場內(S-IP)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_Ill_Pi_STRING = "違規投球(Ill-Pi)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_B_I_STRING = "故意壞球(B-I)"

// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FB = "FB"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FT = "FT"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FC = "FC"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SL = "SL"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CT = "CT"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CH = "CH"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SP = "SP"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CB = "CB"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SC = "SC"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_KN = "KN"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_OT = "OT"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_NO = "?"

// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FB_STRING = "速球(FB)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FT_STRING = "伸卡(FT)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FC_STRING = "快速卡特(FC)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SL_STRING = "滑球(SL)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CT_STRING = "慢速卡特(CT)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CH_STRING = "變速(CH)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SP_STRING = "指叉(SP)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CB_STRING = "曲球(CB)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SC_STRING = "慢速曲球(SC)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_KN_STRING = "彈指(KN)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_OT_STRING = "其他(OT)"
// export const GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_NO_STRING = "未知(?)"

export const action_type_arr = [
    { val: GAME_ACTIONLIST_TYPE_PITCH, name: GAME_ACTIONLIST_TYPE_PITCH_STRING },
    { val: GAME_ACTIONLIST_TYPE_NONBIP, name: GAME_ACTIONLIST_TYPE_NONBIP_STRING },
    { val: GAME_ACTIONLIST_TYPE_MISC, name: GAME_ACTIONLIST_TYPE_MISC_STRING },
    { val: GAME_ACTIONLIST_TYPE_PITCH_BEFORE, name: GAME_ACTIONLIST_TYPE_PITCH_BEFORE_STRING },
    { val: GAME_ACTIONLIST_TYPE_PITCH_AFTER, name: GAME_ACTIONLIST_TYPE_PITCH_AFTER_STRING },
    { val: GAME_ACTIONLIST_TYPE_BASERUNNER, name: GAME_ACTIONLIST_TYPE_BASERUNNER_STRING },
    { val: GAME_ACTIONLIST_TYPE_ADBH, name: GAME_ACTIONLIST_TYPE_ADBH_STRING },
    { val: GAME_ACTIONLIST_TYPE_IPO, name: GAME_ACTIONLIST_TYPE_IPO_STRING },
    { val: GAME_ACTIONLIST_TYPE_IPS, name: GAME_ACTIONLIST_TYPE_IPS_STRING },
]

export const action_type_code_arr = [
    {
        key: GAME_ACTIONLIST_TYPE_PITCH, arr: [
            { val: GAME_ACTIONLIST.PITCH.Strk_C.CODE, name: GAME_ACTIONLIST.PITCH.Strk_C.STRING },
            { val: GAME_ACTIONLIST.PITCH.Strk_S.CODE, name: GAME_ACTIONLIST.PITCH.Strk_S.STRING },
            { val: GAME_ACTIONLIST.PITCH.Foul.CODE, name: GAME_ACTIONLIST.PITCH.Foul.STRING },
            { val: GAME_ACTIONLIST.PITCH.Ball.CODE, name: GAME_ACTIONLIST.PITCH.Ball.STRING },
            { val: GAME_ACTIONLIST.PITCH.In_Play.CODE, name: GAME_ACTIONLIST.PITCH.In_Play.STRING },
            { val: GAME_ACTIONLIST.PITCH.Ball_Ill_Pi.CODE, name: GAME_ACTIONLIST.PITCH.Ball_Ill_Pi.STRING },
            { val: GAME_ACTIONLIST.PITCH.Ball_B_I.CODE, name: GAME_ACTIONLIST.PITCH.Ball_B_I.STRING },
            // { val: GAME_ACTIONLIST_CODE_PITCH_STRK_C, name: GAME_ACTIONLIST_CODE_PITCH_STRK_C_STRING },
            // { val: GAME_ACTIONLIST_CODE_PITCH_STRK_S, name: GAME_ACTIONLIST_CODE_PITCH_STRK_S_STRING },
            // { val: GAME_ACTIONLIST_CODE_PITCH_FOUL, name: GAME_ACTIONLIST_CODE_PITCH_FOUL_STRING },
            // { val: GAME_ACTIONLIST_CODE_PITCH_BALL, name: GAME_ACTIONLIST_CODE_PITCH_BALL_STRING },
            // { val: GAME_ACTIONLIST_CODE_PITCH_INPLAY, name: GAME_ACTIONLIST_CODE_PITCH_INPLAY_STRING },
            // { val: GAME_ACTIONLIST_CODE_PITCH_BIP, name: GAME_ACTIONLIST_CODE_PITCH_BIP_STRING },
            // { val: GAME_ACTIONLIST_CODE_PITCH_BBI, name: GAME_ACTIONLIST_CODE_PITCH_BBI_STRING },
        ]
    },
    {
        key: GAME_ACTIONLIST_TYPE_NONBIP, arr: [
            { val: GAME_ACTIONLIST.NONBIP.Ks.CODE, name: GAME_ACTIONLIST.NONBIP.Ks.STRING },
            { val: GAME_ACTIONLIST.NONBIP.K.CODE, name: GAME_ACTIONLIST.NONBIP.K.STRING },
            { val: GAME_ACTIONLIST.NONBIP.K_SF.CODE, name: GAME_ACTIONLIST.NONBIP.K_SF.STRING },
            { val: GAME_ACTIONLIST.NONBIP.BB.CODE, name: GAME_ACTIONLIST.NONBIP.BB.STRING },
            { val: GAME_ACTIONLIST.NONBIP.BB_I.CODE, name: GAME_ACTIONLIST.NONBIP.BB_I.STRING },
            { val: GAME_ACTIONLIST.NONBIP.BB_IL.CODE, name: GAME_ACTIONLIST.NONBIP.BB_IL.STRING },
            { val: GAME_ACTIONLIST.NONBIP.K_BS.CODE, name: GAME_ACTIONLIST.NONBIP.K_BS.STRING },
            { val: GAME_ACTIONLIST.NONBIP.K_DO.CODE, name: GAME_ACTIONLIST.NONBIP.K_DO.STRING },
            { val: GAME_ACTIONLIST.NONBIP.K_DS.CODE, name: GAME_ACTIONLIST.NONBIP.K_DS.STRING },
            { val: GAME_ACTIONLIST.NONBIP.K_BF.CODE, name: GAME_ACTIONLIST.NONBIP.K_BF.STRING },
            { val: GAME_ACTIONLIST.NONBIP.HBP.CODE, name: GAME_ACTIONLIST.NONBIP.HBP.STRING },
            { val: GAME_ACTIONLIST.NONBIP.IBB.CODE, name: GAME_ACTIONLIST.NONBIP.IBB.STRING },
            { val: GAME_ACTIONLIST.NONBIP.OBC.CODE, name: GAME_ACTIONLIST.NONBIP.OBC.STRING },
            // { val: GAME_ACTIONLIST_CODE_NONBIP_KS, name: GAME_ACTIONLIST_CODE_NONBIP_KS_STRING },
            // { val: GAME_ACTIONLIST_CODE_NONBIP_K, name: GAME_ACTIONLIST_CODE_NONBIP_K_STRING },
            // { val: GAME_ACTIONLIST_CODE_NONBIP_BB, name: GAME_ACTIONLIST_CODE_NONBIP_BB_STRING },
            // { val: GAME_ACTIONLIST_CODE_NONBIP_BBI, name: GAME_ACTIONLIST_CODE_NONBIP_BBI_STRING },
            // { val: GAME_ACTIONLIST_CODE_NONBIP_BBIL, name: GAME_ACTIONLIST_CODE_NONBIP_BBIL_STRING },
            // { val: GAME_ACTIONLIST_CODE_NONBIP_KBS, name: GAME_ACTIONLIST_CODE_NONBIP_KBS_STRING },
            // { val: GAME_ACTIONLIST_CODE_NONBIP_KDO, name: GAME_ACTIONLIST_CODE_NONBIP_KDO_STRING },
            // { val: GAME_ACTIONLIST_CODE_NONBIP_KDS, name: GAME_ACTIONLIST_CODE_NONBIP_KDS_STRING },
            // { val: GAME_ACTIONLIST_CODE_NONBIP_KFB, name: GAME_ACTIONLIST_CODE_NONBIP_KFB_STRING },
            // { val: GAME_ACTIONLIST_CODE_NONBIP_HBP, name: GAME_ACTIONLIST_CODE_NONBIP_HBP_STRING },
            // { val: GAME_ACTIONLIST_CODE_NONBIP_IBB, name: GAME_ACTIONLIST_CODE_NONBIP_IBB_STRING },
        ]
    },
    {
        key: GAME_ACTIONLIST_TYPE_MISC, arr: [
            { val: GAME_ACTIONLIST.MISC.E_Foul.CODE, name: GAME_ACTIONLIST.MISC.E_Foul.STRING },
            { val: GAME_ACTIONLIST.MISC.Ill_Pi.CODE, name: GAME_ACTIONLIST.MISC.Ill_Pi.STRING },
            { val: GAME_ACTIONLIST.MISC.B_I.CODE, name: GAME_ACTIONLIST.MISC.B_I.STRING },
            { val: GAME_ACTIONLIST.MISC.S_BF.CODE, name: GAME_ACTIONLIST.MISC.S_BF.STRING },
            { val: GAME_ACTIONLIST.MISC.S_BS.CODE, name: GAME_ACTIONLIST.MISC.S_BS.STRING },
            { val: GAME_ACTIONLIST.MISC.BK.CODE, name: GAME_ACTIONLIST.MISC.BK.STRING },
            { val: GAME_ACTIONLIST.MISC.UN_P.CODE, name: GAME_ACTIONLIST.MISC.UN_P.STRING },
            // { val: GAME_ACTIONLIST_CODE_MISC_EFOUL, name: GAME_ACTIONLIST_CODE_MISC_EFOUL_STRING },
            // { val: GAME_ACTIONLIST_CODE_MISC_ILLPI, name: GAME_ACTIONLIST_CODE_MISC_ILLPI_STRING },
            // { val: GAME_ACTIONLIST_CODE_MISC_BI, name: GAME_ACTIONLIST_CODE_MISC_BI_STRING },
            // { val: GAME_ACTIONLIST_CODE_MISC_SFB, name: GAME_ACTIONLIST_CODE_MISC_SFB_STRING },
            // { val: GAME_ACTIONLIST_CODE_MISC_SBS, name: GAME_ACTIONLIST_CODE_MISC_SBS_STRING },
            // { val: GAME_ACTIONLIST_CODE_MISC_BK, name: GAME_ACTIONLIST_CODE_MISC_BK_STRING },
            // { val: GAME_ACTIONLIST_CODE_MISC_UNP, name: GAME_ACTIONLIST_CODE_MISC_UNP_STRING },
        ]
    },
    {
        key: GAME_ACTIONLIST_TYPE_PITCH_BEFORE, arr: [
            { val: GAME_ACTIONLIST.PB.PP.CODE, name: GAME_ACTIONLIST.PB.PP.STRING },
            { val: GAME_ACTIONLIST.PB.PPO.CODE, name: GAME_ACTIONLIST.PB.PPO.STRING },
            { val: GAME_ACTIONLIST.PB.CS_PP.CODE, name: GAME_ACTIONLIST.PB.CS_PP.STRING },
            { val: GAME_ACTIONLIST.PB.SB_PP.CODE, name: GAME_ACTIONLIST.PB.SB_PP.STRING },
            { val: GAME_ACTIONLIST.PB.E_TPP.CODE, name: GAME_ACTIONLIST.PB.E_TPP.STRING },
            { val: GAME_ACTIONLIST.PB.E_CPP.CODE, name: GAME_ACTIONLIST.PB.E_CPP.STRING },
            { val: GAME_ACTIONLIST.PB.SB_PB.CODE, name: GAME_ACTIONLIST.PB.SB_PB.STRING },
            { val: GAME_ACTIONLIST.PB.DI_PB.CODE, name: GAME_ACTIONLIST.PB.DI_PB.STRING },
            { val: GAME_ACTIONLIST.PB.E_TOPB.CODE, name: GAME_ACTIONLIST.PB.E_TOPB.STRING },
            { val: GAME_ACTIONLIST.PB.OBPB.CODE, name: GAME_ACTIONLIST.PB.OBPB.STRING },
            { val: GAME_ACTIONLIST.PB.OTO_PB.CODE, name: GAME_ACTIONLIST.PB.OTO_PB.STRING },
            { val: GAME_ACTIONLIST.PB.OTS_PB.CODE, name: GAME_ACTIONLIST.PB.OTS_PB.STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_PP, name: GAME_ACTIONLIST_CODE_PB_PP_STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_PPO, name: GAME_ACTIONLIST_CODE_PB_PPO_STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_CS_PP, name: GAME_ACTIONLIST_CODE_PB_CS_PP_STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_SB_PP, name: GAME_ACTIONLIST_CODE_PB_SB_PP_STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_E_TPP, name: GAME_ACTIONLIST_CODE_PB_E_TPP_STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_E_CPP, name: GAME_ACTIONLIST_CODE_PB_E_CPP_STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_SB_PB, name: GAME_ACTIONLIST_CODE_PB_SB_PB_STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_DI_PB, name: GAME_ACTIONLIST_CODE_PB_DI_PB_STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_E_TOPB, name: GAME_ACTIONLIST_CODE_PB_E_TOPB_STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_OBPB, name: GAME_ACTIONLIST_CODE_PB_OBPB_STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_OTO_PB, name: GAME_ACTIONLIST_CODE_PB_OTO_PB_STRING },
            // { val: GAME_ACTIONLIST_CODE_PB_OTS_PB, name: GAME_ACTIONLIST_CODE_PB_OTS_PB_STRING },
        ]
    },
    {
        key: GAME_ACTIONLIST_TYPE_PITCH_AFTER, arr: [
            { val: GAME_ACTIONLIST.PA.CS_PA.CODE, name: GAME_ACTIONLIST.PA.CS_PA.STRING },
            { val: GAME_ACTIONLIST.PA.CPO.CODE, name: GAME_ACTIONLIST.PA.CPO.STRING },
            { val: GAME_ACTIONLIST.PA.INT_PA.CODE, name: GAME_ACTIONLIST.PA.INT_PA.STRING },
            { val: GAME_ACTIONLIST.PA.SB_PA.CODE, name: GAME_ACTIONLIST.PA.SB_PA.STRING },
            { val: GAME_ACTIONLIST.PA.WP_PA.CODE, name: GAME_ACTIONLIST.PA.WP_PA.STRING },
            { val: GAME_ACTIONLIST.PA.PB_PA.CODE, name: GAME_ACTIONLIST.PA.PB_PA.STRING },
            { val: GAME_ACTIONLIST.PA.DI_PA.CODE, name: GAME_ACTIONLIST.PA.DI_PA.STRING },
            { val: GAME_ACTIONLIST.PA.E_TPA.CODE, name: GAME_ACTIONLIST.PA.E_TPA.STRING },
            { val: GAME_ACTIONLIST.PA.E_CPA.CODE, name: GAME_ACTIONLIST.PA.E_CPA.STRING },
            { val: GAME_ACTIONLIST.PA.E_TOPA.CODE, name: GAME_ACTIONLIST.PA.E_TOPA.STRING },
            { val: GAME_ACTIONLIST.PA.OBPA.CODE, name: GAME_ACTIONLIST.PA.OBPA.STRING },
            { val: GAME_ACTIONLIST.PA.OTO_PA.CODE, name: GAME_ACTIONLIST.PA.OTO_PA.STRING },
            { val: GAME_ACTIONLIST.PA.OTS_PA.CODE, name: GAME_ACTIONLIST.PA.OTS_PA.STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_CS_PA, name: GAME_ACTIONLIST_CODE_PA_CS_PA_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_CPO, name: GAME_ACTIONLIST_CODE_PA_CPO_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_INT_PA, name: GAME_ACTIONLIST_CODE_PA_INT_PA_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_SB_PA, name: GAME_ACTIONLIST_CODE_PA_SB_PA_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_WP_PA, name: GAME_ACTIONLIST_CODE_PA_WP_PA_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_PB_PA, name: GAME_ACTIONLIST_CODE_PA_PB_PA_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_DI_PA, name: GAME_ACTIONLIST_CODE_PA_DI_PA_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_E_TPA, name: GAME_ACTIONLIST_CODE_PA_E_TPA_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_E_CPA, name: GAME_ACTIONLIST_CODE_PA_E_CPA_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_E_TOPA, name: GAME_ACTIONLIST_CODE_PA_E_TOPA_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_OBPA, name: GAME_ACTIONLIST_CODE_PA_OBPA_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_OTO_PA, name: GAME_ACTIONLIST_CODE_PA_OTO_PA_STRING },
            // { val: GAME_ACTIONLIST_CODE_PA_OTS_PA, name: GAME_ACTIONLIST_CODE_PA_OTS_PA_STRING },
        ]
    },
    {
        key: GAME_ACTIONLIST_TYPE_BASERUNNER, arr: [
            { val: GAME_ACTIONLIST.BR.RO01.CODE, name: GAME_ACTIONLIST.BR.RO01.STRING },
            { val: GAME_ACTIONLIST.BR.RO02.CODE, name: GAME_ACTIONLIST.BR.RO02.STRING },
            { val: GAME_ACTIONLIST.BR.RO03.CODE, name: GAME_ACTIONLIST.BR.RO03.STRING },
            { val: GAME_ACTIONLIST.BR.RO04.CODE, name: GAME_ACTIONLIST.BR.RO04.STRING },
            { val: GAME_ACTIONLIST.BR.CS_BR.CODE, name: GAME_ACTIONLIST.BR.CS_BR.STRING },
            { val: GAME_ACTIONLIST.BR.RO05.CODE, name: GAME_ACTIONLIST.BR.RO05.STRING },
            { val: GAME_ACTIONLIST.BR.RS01.CODE, name: GAME_ACTIONLIST.BR.RS01.STRING },
            { val: GAME_ACTIONLIST.BR.E_TRS.CODE, name: GAME_ACTIONLIST.BR.E_TRS.STRING },
            { val: GAME_ACTIONLIST.BR.E_CRS.CODE, name: GAME_ACTIONLIST.BR.E_CRS.STRING },
            { val: GAME_ACTIONLIST.BR.E_TORS.CODE, name: GAME_ACTIONLIST.BR.E_TORS.STRING },
            { val: GAME_ACTIONLIST.BR.SB_BR.CODE, name: GAME_ACTIONLIST.BR.SB_BR.STRING },
            { val: GAME_ACTIONLIST.BR.WP_BR.CODE, name: GAME_ACTIONLIST.BR.WP_BR.STRING },
            { val: GAME_ACTIONLIST.BR.PB_BR.CODE, name: GAME_ACTIONLIST.BR.PB_BR.STRING },
            { val: GAME_ACTIONLIST.BR.UN_RO.CODE, name: GAME_ACTIONLIST.BR.UN_RO.STRING },
            { val: GAME_ACTIONLIST.BR.UN_RS.CODE, name: GAME_ACTIONLIST.BR.UN_RS.STRING },
            { val: GAME_ACTIONLIST.BR.RO11.CODE, name: GAME_ACTIONLIST.BR.RO11.STRING },
            { val: GAME_ACTIONLIST.BR.RO12.CODE, name: GAME_ACTIONLIST.BR.RO12.STRING },
            { val: GAME_ACTIONLIST.BR.RO13.CODE, name: GAME_ACTIONLIST.BR.RO13.STRING },
            { val: GAME_ACTIONLIST.BR.RO14.CODE, name: GAME_ACTIONLIST.BR.RO14.STRING },
            { val: GAME_ACTIONLIST.BR.RO15.CODE, name: GAME_ACTIONLIST.BR.RO15.STRING },
            { val: GAME_ACTIONLIST.BR.OT_RO.CODE, name: GAME_ACTIONLIST.BR.OT_RO.STRING },
            { val: GAME_ACTIONLIST.BR.OBRS.CODE, name: GAME_ACTIONLIST.BR.OBRS.STRING },
            { val: GAME_ACTIONLIST.BR.E_TH.CODE, name: GAME_ACTIONLIST.BR.E_TH.STRING },
            { val: GAME_ACTIONLIST.BR.OT_RS.CODE, name: GAME_ACTIONLIST.BR.OT_RS.STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_RO01, name: GAME_ACTIONLIST_CODE_BR_RO01_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_RO02, name: GAME_ACTIONLIST_CODE_BR_RO02_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_RO03, name: GAME_ACTIONLIST_CODE_BR_RO03_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_RO04, name: GAME_ACTIONLIST_CODE_BR_RO04_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_CS_BR, name: GAME_ACTIONLIST_CODE_BR_CS_BR_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_RO05, name: GAME_ACTIONLIST_CODE_BR_RO05_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_RS01, name: GAME_ACTIONLIST_CODE_BR_RS01_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_E_TRS, name: GAME_ACTIONLIST_CODE_BR_E_TRS_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_E_CRS, name: GAME_ACTIONLIST_CODE_BR_E_CRS_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_E_TORS, name: GAME_ACTIONLIST_CODE_BR_E_TORS_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_SB_BR, name: GAME_ACTIONLIST_CODE_BR_SB_BR_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_WP_BR, name: GAME_ACTIONLIST_CODE_BR_WP_BR_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_PB_BR, name: GAME_ACTIONLIST_CODE_BR_PB_BR_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_UN_RO, name: GAME_ACTIONLIST_CODE_BR_UN_RO_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_UN_RS, name: GAME_ACTIONLIST_CODE_BR_UN_RS_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_RO11, name: GAME_ACTIONLIST_CODE_BR_RO11_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_RO12, name: GAME_ACTIONLIST_CODE_BR_RO12_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_RO13, name: GAME_ACTIONLIST_CODE_BR_RO13_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_RO14, name: GAME_ACTIONLIST_CODE_BR_RO14_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_RO15, name: GAME_ACTIONLIST_CODE_BR_RO15_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_OT_RO, name: GAME_ACTIONLIST_CODE_BR_OT_RO_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_OBRS, name: GAME_ACTIONLIST_CODE_BR_OBRS_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_E_TH, name: GAME_ACTIONLIST_CODE_BR_E_TH_STRING },
            // { val: GAME_ACTIONLIST_CODE_BR_OT_RS, name: GAME_ACTIONLIST_CODE_BR_OT_RS_STRING },

        ]
    }, {
        key: GAME_ACTIONLIST_TYPE_ADBH, arr: [
            { val: GAME_ACTIONLIST.ADBH.ABH.CODE, name: GAME_ACTIONLIST.ADBH.ABH.STRING },
            // { val: GAME_ACTIONLIST_CODE_ADBH_AdBH, name: GAME_ACTIONLIST_CODE_ADBH_AdBH_STRING },
        ]
    },
    {
        key: GAME_ACTIONLIST_TYPE_IPO, arr: [
            { val: GAME_ACTIONLIST.IPO.G.CODE, name: GAME_ACTIONLIST.IPO.G.STRING },
            { val: GAME_ACTIONLIST.IPO.G_.CODE, name: GAME_ACTIONLIST.IPO.G_.STRING },
            { val: GAME_ACTIONLIST.IPO.GT.CODE, name: GAME_ACTIONLIST.IPO.GT.STRING },
            { val: GAME_ACTIONLIST.IPO.F.CODE, name: GAME_ACTIONLIST.IPO.F.STRING },
            { val: GAME_ACTIONLIST.IPO.SH.CODE, name: GAME_ACTIONLIST.IPO.SH.STRING },
            { val: GAME_ACTIONLIST.IPO.SF.CODE, name: GAME_ACTIONLIST.IPO.SF.STRING },
            { val: GAME_ACTIONLIST.IPO.IF.CODE, name: GAME_ACTIONLIST.IPO.IF.STRING },
            { val: GAME_ACTIONLIST.IPO.INT.CODE, name: GAME_ACTIONLIST.IPO.INT.STRING },
            { val: GAME_ACTIONLIST.IPO.LO.CODE, name: GAME_ACTIONLIST.IPO.LO.STRING },
            { val: GAME_ACTIONLIST.IPO.OT_PO.CODE, name: GAME_ACTIONLIST.IPO.OT_PO.STRING },
            { val: GAME_ACTIONLIST.IPO.UN_IO.CODE, name: GAME_ACTIONLIST.IPO.UN_IO.STRING },
            { val: GAME_ACTIONLIST.IPO.DP.CODE, name: GAME_ACTIONLIST.IPO.DP.STRING },
            { val: GAME_ACTIONLIST.IPO.TP.CODE, name: GAME_ACTIONLIST.IPO.TP.STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_G, name: GAME_ACTIONLIST_CODE_IPO_G_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_G_, name: GAME_ACTIONLIST_CODE_IPO_G__STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_GT, name: GAME_ACTIONLIST_CODE_IPO_GT_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_F, name: GAME_ACTIONLIST_CODE_IPO_F_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_SH, name: GAME_ACTIONLIST_CODE_IPO_SH_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_SF, name: GAME_ACTIONLIST_CODE_IPO_SF_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_IF, name: GAME_ACTIONLIST_CODE_IPO_IF_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_INT, name: GAME_ACTIONLIST_CODE_IPO_INT_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_LO, name: GAME_ACTIONLIST_CODE_IPO_LO_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_OT_PO, name: GAME_ACTIONLIST_CODE_IPO_OT_PO_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_UN_IO, name: GAME_ACTIONLIST_CODE_IPO_UN_IO_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_DP, name: GAME_ACTIONLIST_CODE_IPO_DP_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPO_TP, name: GAME_ACTIONLIST_CODE_IPO_TP_STRING },
        ]
    },
    {
        key: GAME_ACTIONLIST_TYPE_IPS, arr: [
            { val: GAME_ACTIONLIST.IPS.S1B.CODE, name: GAME_ACTIONLIST.IPS.S1B.STRING },
            { val: GAME_ACTIONLIST.IPS.S2B.CODE, name: GAME_ACTIONLIST.IPS.S2B.STRING },
            { val: GAME_ACTIONLIST.IPS.S3B.CODE, name: GAME_ACTIONLIST.IPS.S3B.STRING },
            { val: GAME_ACTIONLIST.IPS.HR.CODE, name: GAME_ACTIONLIST.IPS.HR.STRING },
            { val: GAME_ACTIONLIST.IPS.IHR.CODE, name: GAME_ACTIONLIST.IPS.IHR.STRING },
            { val: GAME_ACTIONLIST.IPS.E_C.CODE, name: GAME_ACTIONLIST.IPS.E_C.STRING },
            { val: GAME_ACTIONLIST.IPS.E_T.CODE, name: GAME_ACTIONLIST.IPS.E_T.STRING },
            { val: GAME_ACTIONLIST.IPS.FOT.CODE, name: GAME_ACTIONLIST.IPS.FOT.STRING },
            { val: GAME_ACTIONLIST.IPS.FC.CODE, name: GAME_ACTIONLIST.IPS.FC.STRING },
            { val: GAME_ACTIONLIST.IPS.OBD.CODE, name: GAME_ACTIONLIST.IPS.OBD.STRING },
            { val: GAME_ACTIONLIST.IPS.UN_IP.CODE, name: GAME_ACTIONLIST.IPS.UN_IP.STRING },
            { val: GAME_ACTIONLIST.IPS.DP_S.CODE, name: GAME_ACTIONLIST.IPS.DP_S.STRING },
            { val: GAME_ACTIONLIST.IPS.E_SF.CODE, name: GAME_ACTIONLIST.IPS.E_SF.STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_1B, name: GAME_ACTIONLIST_CODE_IPS_1B_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_2B, name: GAME_ACTIONLIST_CODE_IPS_2B_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_3B, name: GAME_ACTIONLIST_CODE_IPS_3B_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_HR, name: GAME_ACTIONLIST_CODE_IPS_HR_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_IHR, name: GAME_ACTIONLIST_CODE_IPS_IHR_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_E_C, name: GAME_ACTIONLIST_CODE_IPS_E_C_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_E_T, name: GAME_ACTIONLIST_CODE_IPS_E_T_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_FC, name: GAME_ACTIONLIST_CODE_IPS_FC_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_OBC, name: GAME_ACTIONLIST_CODE_IPS_OBC_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_OBD, name: GAME_ACTIONLIST_CODE_IPS_OBD_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_UN_IP, name: GAME_ACTIONLIST_CODE_IPS_UN_IP_STRING },
            // { val: GAME_ACTIONLIST_CODE_IPS_DP_S, name: GAME_ACTIONLIST_CODE_IPS_DP_S_STRING },
        ]
    }, {
        key: GAME_ACTIONLIST_TYPE_NACT, arr: [
            { val: GAME_ACTIONLIST.NACT.RBI.CODE, name: GAME_ACTIONLIST.NACT.RBI.STRING },
            { val: GAME_ACTIONLIST.NACT.R.CODE, name: GAME_ACTIONLIST.NACT.R.STRING },
            { val: GAME_ACTIONLIST.NACT.ER.CODE, name: GAME_ACTIONLIST.NACT.ER.STRING },
            // { val: GAME_ACTIONLIST_CODE_NACT_RBI, name: GAME_ACTIONLIST_CODE_NACT_RBI_STRING },
            // { val: GAME_ACTIONLIST_CODE_NACT_R, name: GAME_ACTIONLIST_CODE_NACT_R_STRING },
            // { val: GAME_ACTIONLIST_CODE_NACT_ER, name: GAME_ACTIONLIST_CODE_NACT_ER_STRING },
        ]
    },
]


export const pitch_result_arr = [
    { val: GAME_ACTIONLIST.PITCH_RESULT.S_C.CODE, name: GAME_ACTIONLIST.PITCH_RESULT.S_C.STRING },
    { val: GAME_ACTIONLIST.PITCH_RESULT.S_S.CODE, name: GAME_ACTIONLIST.PITCH_RESULT.S_S.STRING },
    { val: GAME_ACTIONLIST.PITCH_RESULT.S_FB.CODE, name: GAME_ACTIONLIST.PITCH_RESULT.S_FB.STRING },
    { val: GAME_ACTIONLIST.PITCH_RESULT.Ball.CODE, name: GAME_ACTIONLIST.PITCH_RESULT.Ball.STRING },
    { val: GAME_ACTIONLIST.PITCH_RESULT.S_IP.CODE, name: GAME_ACTIONLIST.PITCH_RESULT.S_IP.STRING },
    { val: GAME_ACTIONLIST.PITCH_RESULT.Ill_Pi.CODE, name: GAME_ACTIONLIST.PITCH_RESULT.Ill_Pi.STRING },
    { val: GAME_ACTIONLIST.PITCH_RESULT.B_I.CODE, name: GAME_ACTIONLIST.PITCH_RESULT.B_I.STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_C, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_C_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_S, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_S_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_FB, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_FB_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_Ball, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_Ball_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_IP, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_S_IP_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_Ill_Pi, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_Ill_Pi_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODES_B_I, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_B_I_STRING },
]

export const pitch_type_arr = [
    { val: GAME_ACTIONLIST.PITCH_TYPE.FB.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.FB.STRING },
    { val: GAME_ACTIONLIST.PITCH_TYPE.FT.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.FT.STRING },
    { val: GAME_ACTIONLIST.PITCH_TYPE.CT.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.CT.STRING },
    { val: GAME_ACTIONLIST.PITCH_TYPE.SL.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.SL.STRING },
    { val: GAME_ACTIONLIST.PITCH_TYPE.CB.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.CB.STRING },
    { val: GAME_ACTIONLIST.PITCH_TYPE.CH.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.CH.STRING },
    { val: GAME_ACTIONLIST.PITCH_TYPE.SP.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.SP.STRING },
    { val: GAME_ACTIONLIST.PITCH_TYPE.SFF.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.SFF.STRING },
    { val: GAME_ACTIONLIST.PITCH_TYPE.SC.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.SC.STRING },
    { val: GAME_ACTIONLIST.PITCH_TYPE.KN.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.KN.STRING },
    { val: GAME_ACTIONLIST.PITCH_TYPE.OT.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.OT.STRING },
    { val: GAME_ACTIONLIST.PITCH_TYPE.NO.CODE, name: GAME_ACTIONLIST.PITCH_TYPE.NO.STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FB, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FB_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FT, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FT_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FC, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_FC_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SL, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SL_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CT, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CT_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CH, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CH_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SP, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SP_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CB, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_CB_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SC, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_SC_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_KN, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_KN_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_OT, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_OT_STRING },
    // { val: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_NO, name: GAME_ACTIONLIST_CODE_PITCH_RESULT_CODE_NO_STRING },
]

export const BAT_TAG = {
    HardTag: {
        SOFT: { CODE: "SOFT", STRING: "SOFT(軟弱)" },
        MED: { CODE: "MED", STRING: "MED(中等)" },
        HARD: { CODE: "HARD", STRING: "HARD(強勁)" },
    },
    HitType: {
        GROUND: { CODE: "GROUND", STRING: "GROUND(滾地)" },
        LINE: { CODE: "LINE", STRING: "LINE(平飛)" },
        FLYB: { CODE: "FLYB", STRING: "FLYB(高飛)" },
        POPB: { CODE: "POPB", STRING: "POPB(內飛)" },
    },
    BuntTag: {
        None: { CODE: "None", STRING: "None(無)" },
        BUNT: { CODE: "BUNT", STRING: "BUNT(觸擊)" },
        SBUNT: { CODE: "SBUNT", STRING: "SBUNT(偷點)" },
    },
    HitTag: {
        None: { CODE: "None", STRING: "None(無)" },
        INFH: { CODE: "INFH", STRING: "INFH(內野安打)" },
        GRH: { CODE: "GRH", STRING: "GRH(場地安打)" },
    }
}

export const hardTag_arr = [
    { val: BAT_TAG.HardTag.SOFT.CODE, name: BAT_TAG.HardTag.SOFT.STRING },
    { val: BAT_TAG.HardTag.MED.CODE, name: BAT_TAG.HardTag.MED.STRING },
    { val: BAT_TAG.HardTag.HARD.CODE, name: BAT_TAG.HardTag.HARD.STRING },
]

export const hitType_arr = [
    { val: BAT_TAG.HitType.GROUND.CODE, name: BAT_TAG.HitType.GROUND.STRING },
    { val: BAT_TAG.HitType.LINE.CODE, name: BAT_TAG.HitType.LINE.STRING },
    { val: BAT_TAG.HitType.FLYB.CODE, name: BAT_TAG.HitType.FLYB.STRING },
    { val: BAT_TAG.HitType.POPB.CODE, name: BAT_TAG.HitType.POPB.STRING },
]

export const buntTag_arr1 = [
    { val: BAT_TAG.BuntTag.BUNT.CODE, name: BAT_TAG.BuntTag.BUNT.STRING },
    { val: BAT_TAG.BuntTag.SBUNT.CODE, name: BAT_TAG.BuntTag.SBUNT.STRING },
]

export const buntTag_arr2 = [
    { val: BAT_TAG.BuntTag.None.CODE, name: BAT_TAG.BuntTag.None.STRING },
    { val: BAT_TAG.BuntTag.BUNT.CODE, name: BAT_TAG.BuntTag.BUNT.STRING },
    { val: BAT_TAG.BuntTag.SBUNT.CODE, name: BAT_TAG.BuntTag.SBUNT.STRING },
]

export const hitTag_arr = [
    { val: BAT_TAG.HitTag.None.CODE, name: BAT_TAG.HitTag.None.STRING },
    { val: BAT_TAG.HitTag.INFH.CODE, name: BAT_TAG.HitTag.INFH.STRING },
    { val: BAT_TAG.HitTag.GRH.CODE, name: BAT_TAG.HitTag.GRH.STRING },
]


//以“Action Type/Code”搜尋
export class ReqAction2ActionList {
    constructor({
        start = 0,            //開始
        limit = 10,           //一次幾筆
        game_id,
        inning = "",          //局數
        inning_half = "",     //上下半局
        action_type = "",
        action_code = "",
        player_name = "",     //球員名稱
        result_code = "",     //成績代碼
    }) {
        this.start = start
        this.limit = limit
        this.game_id = game_id
        this.inning = inning
        this.inning_half = inning_half
        this.action_type = action_type
        this.action_code = action_code
        this.player_name = player_name
        this.result_code = result_code
    }
}

//以“Pitch Result”搜尋
export class ReqPitch2ActionList {
    constructor({
        start = 0,                //開始
        limit = 10,               //一次幾筆
        game_id,
        inning = "",              //局數
        inning_half = "",         //上下半局
        pitch_result_code = "",   //投球成績代碼
        pitch_type = "",          //投球球種
        player_name = "",         //球員名稱
        result_code = "",         //成績代碼
    }) {
        this.start = start
        this.limit = limit
        this.game_id = game_id
        this.inning = inning
        this.inning_half = inning_half
        this.pitch_result_code = pitch_result_code
        this.pitch_type = pitch_type
        // this.action_type=action_type
        // this.action_code=action_code
        this.player_name = player_name
        this.result_code = result_code
    }
}

// export class ActionLists {
//     fromJson(items) {
//         this.items = []
//         items.forEach(item => {
//             var mRespActionList = new RespActionList({})
//             this.items.push(mRespActionList)
//         })
//         console.log(this.items)
//     }
// }

export class RespActionList {
    constructor({   //時機	ACT	投球結果	打席結果	壘上	ACT數據	成績
        record_id,                  //動作成績id
        plate_id,                   //打席資料id
        inning,                     //時機 - 局數
        inning_half,                //時機 - 上下半局
        pa_no,                      //時機 - 棒次
        offensive,                  //時機 - 打擊球員資料
        defensive,                  //時機 - 投手球員資料
        action_type,                //ACT- type(縮寫)
        action_code,                //ACT - code
        action_detail,
        current_strikes,            //ACT - 好球數 (type是pitch才需要)
        current_balls,              //ACT - 壞球數 (type是pitch才需要)
        current_outs,               //ACT - 出局數 (type是pitch才需要)
        pitch_result_code,          //投球結果 - 投球成績代碼
        pitch_type,                 //投球結果 - 投球球種
        pitch_speed,                //投球結果 - 球速
        pa_result,                  //打席結果
        defense_pass,               //打席結果 - 傳接球 (資料在 action_detail > defense > pass, 是個 array)
        first_base_player_id,       //壘上 - 目前一壘球員
        second_base_player_id,      //壘上 - 目前二壘球員
        third_base_player_id,       //壘上 - 目前三壘球員
        move_time,                  //ACT數據(投球數據) - 影片時間
        pitchingSouce,              //小懷數據
        // IR_time,                    //ACT數據(投球數據) - 小懷時間
        // SpinAXIS,                   //ACT數據(投球數據) - 小懷數據轉軸
        // SpinRate,                   //ACT數據 (投球數據)- 小懷數據轉速
        // SpinEFF,                    //ACT數據(投球數據) - 小懷數據SpinEFF%
        //擊球初速+擊球仰角+HitType
        transcript,                 //成績 - 一個json array, 列出要顯示的每筆成績
        pitchingSource,
        video_timestamp,
        isChoose,

    }) {
        this.inning = inning
    }

    fromJson(jsonData) {
        // console.log(jsonData)
        // console.log(1)
        // var offensive_team = jsonData.inning_half === 1 ? jsonData.away : jsonData.home
        // var defensive_team = jsonData.inning_half === 1 ? jsonData.home : jsonData.away
        // offensive_team = JSON.parse(offensive_team) || {}
        // defensive_team = JSON.parse(defensive_team) || {}
        // var total = defensive_team.length
        // var pitcher = null
        // console.log(defensive_team)
        // for (var i = 0; i < total; i++) {
        //     if (defensive_team[i].type === "P") {
        //         pitcher = defensive_team[i]
        //     }
        // }

        this.record_id = jsonData.record_id
        this.plate_id = jsonData.plate_id
        this.inning = jsonData.inning
        this.inning_half = jsonData.inning_half
        this.pa_no = jsonData.pa_no
        this.offensive = jsonData.offensive
        this.defensive = jsonData.defensive
        this.action_type = jsonData.action_type
        this.action_code = jsonData.action_code
        this.action_detail = JSON.parse(jsonData.action_detail) || {}
        this.current_strikes = jsonData.current_strikes
        this.current_balls = jsonData.current_balls
        this.current_outs = jsonData.current_outs
        this.pitch_result_code = jsonData.pitch_result_code
        this.pitch_type = jsonData.pitch_type
        this.pitch_speed = jsonData.pitch_speed
        this.pa_result = jsonData.pa_result
        this.defense_pass = jsonData.defense_pass
        // this.first_base_player_id = jsonData.first_base_player_id
        // this.second_base_player_id = jsonData.second_base_player_id
        // this.third_base_player_id = jsonData.third_base_player_id
        this.after_status = jsonData.after_status
        this.before_status = jsonData.before_status
        // this.move_time = jsonData.move_time
        // this.IR_time = jsonData.IR_time
        // this.SpinAXIS = jsonData.SpinAXIS
        // this.SpinRate = jsonData.SpinRate
        // this.SpinEFF = jsonData.SpinEFF
        this.transcript = jsonData.transcript
        this.pitchingSource = jsonData.pitchingSource
        this.video_timestamp = jsonData.video_timestamp
        this.isChoose = jsonData.isChoose || false
    }

    get_opportunity({ index }) {
        // console.log("get_opportunity")
        var inning_half_string = get_inning_half_string(this.inning_half)
        // console.log(inning_half_string)
        var offensive_player_name = this.offensive["player"]["player_name"]
        var offensive_batter_handeness = this.offensive["batter_handeness"] === 1 ? "L" : "R"
        var defensive_player_name = this.defensive["player"]["player_name"]
        var defensive_batter_handeness = this.defensive["pitcher_handeness"] === 1 ? "L" : "R"
        // console.log(offensive_player_name)
        var text = this.inning + inning_half_string + "/" + offensive_player_name + offensive_batter_handeness + "/" + defensive_player_name + defensive_batter_handeness
        if (index != null)
            text = "[" + index + "]" + text
        return text
    }

    get_act_code() {
        return getActionTypeCode(this.action_type) + "/" + this.action_code
    }

    get_act_current() {
        var current = []
        current.push(this.current_strikes)
        current.push(this.current_balls)
        current.push(this.current_outs)
        return current.join("-")
    }

    get_pitch_result() {
        var result = []
        if (this.action_type === GAME_ACTIONLIST_TYPE_PITCH) {
            this.set_act(result, this.pitch_result_code, "")
            this.set_act(result, this.pitch_type, "")
            this.set_act(result, this.pitch_speed, "")
            // if (this.pitch_speed !== "" && this.pitch_speed !== null) {
            // } else if (this.pitchingSource !== null) {
            //     this.set_act(result, this.pitchingSource.VeloRel, "")
            // }
            if (this.pitchingSource !== null)
                this.set_act(result, this.pitchingSource.Clip_Id, "")
            // if (this.pitch_result_code !== "" && this.pitch_result_code !== null)
            //     result.push(this.pitch_result_code)
            // if (this.pitch_type !== "" && this.pitch_type !== null)
            //     result.push(this.pitch_type)
            // if (this.pitchingSource !== null && this.pitchingSource.Clip_Id != null && this.pitchingSource.Clip_Id !== "")
            //     result.push(this.pitchingSource.Clip_Id)
        }
        if (result.length > 0)
            return result.join(",")
        else
            return "-"
    }

    get_play_result() {
        var pitchResult = []
        switch (this.action_type) {
            case GAME_ACTIONLIST_TYPE_ADBH:
                break;
            default:
                var defense_pass = ""
                var pa_result = this.set_pa_result()
                if (pa_result !== "")
                    pitchResult.push(pa_result)
                try {
                    // console.log(mRespActionList.action_detail.defense.pass)
                    defense_pass = this.action_detail.defense.pass.join("-")
                    // console.log(defense_pass)
                    pitchResult.push(defense_pass)
                } catch (error) {
                    defense_pass = ""
                }
                break;
        }
        return pitchResult;
    }

    set_pa_result() {
        var has_result = false
        switch (this.action_type) {
            // case GAME_ACTIONLIST_TYPE_PITCH:
            case GAME_ACTIONLIST_TYPE_NONBIP:
            case GAME_ACTIONLIST_TYPE_IPO:
            case GAME_ACTIONLIST_TYPE_IPS:
                has_result = true
                break
            // case GAME_ACTIONLIST_TYPE_MISC:
            // case GAME_ACTIONLIST_TYPE_PITCH_BEFORE:
            // case GAME_ACTIONLIST_TYPE_PITCH_AFTER:
            // case GAME_ACTIONLIST_TYPE_BASERUNNER:
            // case GAME_ACTIONLIST_TYPE_ADBH:
            // case GAME_ACTIONLIST_TYPE_NACT:
            default:
                break
        }
        if (has_result)
            return this.pa_result
        else {
            return ""
        }

    }

    get_act() {
        var act = []
        if (this.action_type === GAME_ACTIONLIST_TYPE_IPS || this.action_type === GAME_ACTIONLIST_TYPE_IPO) {
            var bat = []
            var exit = []
            if (this.pitchingSource != null) {
                this.set_act(exit, this.pitchingSource.ExitVelo, "")
                this.set_act(exit, this.pitchingSource.ExitAngle, "")
                console.log(this.pitchingSource.ExitAngle)
            }
            bat.push(exit.join(","))
            bat.push(this.get_act_bat().join(","))
            if (bat.length > 0)
                act.push(bat)
        } else if (this.action_detail.pitch != null) {
            // console.log("this.action_detail.pitch")
            var patch = []
            var timeString = [];
            if (this.video_timestamp != null) {
                var vt = moment(this.video_timestamp).format('HH:mm:ss');
                if (vt === "00:00:00")
                    timeString.push("-")
                else
                    timeString.push(vt)
            } else {
                timeString.push("-")
            }
            if (this.pitchingSource != null && this.pitchingSource.PitchTime != null) {
                this.set_act(timeString, this.pitchingSource.PitchTime, "")
            } else {
                timeString.push("-")
            }

            patch.push(timeString.join("/"))
            patch.push(this.get_act_pitch().join(","))
            if (patch.length > 0)
                act.push(patch)
        }
        if (this.action_detail.run != null) {
            // console.log("this.action_detail.run")
            var run = this.get_act_run()
            if (run.length > 0)
                act.push(run)
        }
        return act
    }

    get_act_pitch() {
        var pitch = []
        if (this.pitchingSource != null) {
            this.set_act(pitch, this.pitchingSource.SpinClock, "")
            this.set_act(pitch, this.pitchingSource.SpinRate, "")
            this.set_act(pitch, this.pitchingSource.SpinEFF, "%")
        }
        return pitch
    }

    get_act_bat() {
        //擊球初速 + 擊球仰角+ HitType + HardTag + BuntTag + HitTag
        var bat = []
        if (this.action_detail.bat != null) {
            // console.log(this.action_detail.bat)
            if (this.action_detail.bat.HitType !== null && this.action_detail.bat.HitType !== "")
                bat.push(this.action_detail.bat.HitType)
            if (this.action_detail.bat.HardTag !== null && this.action_detail.bat.HardTag !== "")
                bat.push(this.action_detail.bat.HardTag)
            if (this.action_detail.bat.BuntTag !== null && this.action_detail.bat.BuntTag !== "")
                bat.push(this.action_detail.bat.BuntTag)
            if (this.action_detail.bat.HitTag !== null && this.action_detail.bat.HitTag !== "")
                bat.push(this.action_detail.bat.HitTag)
        }
        return bat
    }

    get_act_run() {
        var run = []
        // console.log("this.action_detail.run")
        if (this.action_detail.run != null) {
            // console.log(this.action_detail.run)
            this.action_detail.run.forEach(item => {
                run.push("(" + item.player.player_name + " , " + this.setBaseNumber(item.startBase) + "-" + this.setBaseNumber(item.endBase) + " , " + (item.isOut === 1 ? "O" : "S") + ") ")
            })
        }
        return run
    }

    set_act(arr, val, att) {
        arr.push(this._set_act(val, att))
    }

    _set_act(val, att) {
        if (val == null || val === "" || val === 0 || val === "00:00" || val === "00:00:00" || val === -1.1)
            return 'NA'
        else
            return val + att
    }

    setBaseNumber(base) {
        if (base === "1B")
            return "1"
        else if (base === "2B")
            return "2"
        else if (base === "3B")
            return "3"
        else return base
    }

    get_before_status() {
        var onbase = []
        var first = 0;
        first += this.before_status.first_base_player_id ? 1 : 0
        first += this.before_status.first_base_player_lead_id ? 1 : 0
        onbase.push(first)

        var second = 0;
        second += this.before_status.second_base_player_id ? 1 : 0
        second += this.before_status.second_base_player_lead_id ? 1 : 0
        onbase.push(second)

        var third = 0;
        third += this.before_status.third_base_player_id ? 1 : 0
        third += this.before_status.third_base_player_lead_id ? 1 : 0
        onbase.push(third)

        return onbase.join("-")
    }
    get_after_status() {
        var onbase = []
        var first = 0;
        first += this.after_status.first_base_player_id ? 1 : 0
        first += this.after_status.first_base_player_lead_id ? 1 : 0
        onbase.push(first)

        var second = 0;
        second += this.after_status.second_base_player_id ? 1 : 0
        second += this.after_status.second_base_player_lead_id ? 1 : 0
        onbase.push(second)

        var third = 0;
        third += this.after_status.third_base_player_id ? 1 : 0
        third += this.after_status.third_base_player_lead_id ? 1 : 0
        onbase.push(third)

        return onbase.join("-")
    }


    get_transcript() {
        var items = []
        var pitcher_catcher_defensive = []
        if (this.transcript["pitcher_defensive"] !== null)
            pitcher_catcher_defensive.concat(this.transcript["pitcher_defensive"])
        if (this.transcript["catcher_defensive"] !== null)
            pitcher_catcher_defensive.concat(this.transcript["catcher_defensive"])
        //this.transcript["pitcher_defensive"].concat(this.transcript["catcher_defensive"])

        var pitcher = this.transcript["pitcher"]
        try{
            pitcher = this.transcript["pitcher"].concat(this.transcript["pitcher_defensive"])
        }catch(e){}

        var defensive = this.transcript["defensive"]
        try{
            var defensive = this.transcript["defensive"].concat(this.transcript["catcher_defensive"])
        }catch(e){

        }


        items = get_transcript_item(pitcher, "投手", items)
        items = get_transcript_item(this.transcript["batter"], "打者", items)
        items = get_transcript_item(defensive, "守備", items)
        items = get_transcript_item(this.pitcher_catcher_defensive, "投捕", items)
        items = get_transcript_item(this.transcript["runner"], "跑者", items)
        // console.log(items)
        return items
    }


    getPitchType() {
        // if (this.action_detail !== undefined && Object.keys(this.action_detail).length > 0) {
        //     // console.log(this.action_detail)
        //     if(this.action_detail.pitch !== undefined && this.action_detail.pitch !== null){
        //         return this.action_detail.pitch.type
        //     }
        //     return ""
        // }
        // return ""
        return this.pitch_type
    }

    getPitchSpeed() {
        return this.pitch_speed
    }

    get_ClipId() {
        return this.get_pitchingSource("Clip_Id")
    }

    get_VeloRel() {
        return this.get_pitchingSource("VeloRel")
    }

    get_PitchTime() {
        return this.get_pitchingSource("PitchTime")
    }

    get_KZone() {
        return this.get_pitchingSource("KZone")
    }

    get_SpinClock() {
        return this.get_pitchingSource("SpinClock")
    }

    get_SpinRate() {
        return this.get_pitchingSource("SpinRate")
    }

    get_TrueSpin() {
        return this.get_pitchingSource("TrueSpin")
    }

    get_Gyro() {
        return this.get_pitchingSource("Gyro")
    }

    get_SpinEFF() {
        return this.get_pitchingSource("SpinEFF")
    }

    get_ExitVelo() {
        return this.get_pitchingSource("ExitVelo")
    }

    get_ExitAngle() {
        return this.get_pitchingSource("ExitAngle")
    }

    get_ExitDirect() {
        return this.get_pitchingSource("ExitDirect")
    }

    get_pitchingSource(key) {
        if (this.pitchingSource !== undefined && this.pitchingSource !== null) {
            switch (key) {
                case "Clip_Id":
                    return this._set_act(this.pitchingSource.Clip_Id, "")
                case "VeloRel":
                    return this._set_act(this.pitchingSource.VeloRel, "")
                case "PitchTime":
                    return this._set_act(this.pitchingSource.PitchTime, "")
                case "KZone":
                    return "(" + this.pitchingSource.KZoneY + "," + this.pitchingSource.KZoneZ + ")"
                case "SpinClock":
                    return this._set_act(this.pitchingSource.SpinClock, "")
                case "SpinRate":
                    return this._set_act(this.pitchingSource.SpinRate, "")
                case "TrueSpin":
                    return this._set_act(this.pitchingSource.TrueSpin, "")
                case "Gyro":
                    return this._set_act(this.pitchingSource.Gyro, "")
                case "SpinEFF":
                    return this._set_act(this.pitchingSource.SpinEFF, "")
                case "ExitVelo":
                    return this._set_act(this.pitchingSource.ExitVelo, "")
                case "ExitAngle":
                    return this._set_act(this.pitchingSource.ExitAngle, "")
                case "ExitDirect":
                    return this._set_act(this.pitchingSource.ExitDirect, "")
                default:
                    return "N/A"
            }
        }
        return "N/A"
    }

    get_HardTag() {
        return this.get_Bat("HardTag")
    }
    get_HitType() {
        return this.get_Bat("HitType")
    }

    get_BuntTag() {
        return this.get_Bat("BuntTag")
    }

    get_HitTag() {
        return this.get_Bat("HitTag")
    }


    get_Bat(key) {
        if (this.action_detail !== undefined && Object.keys(this.action_detail).length > 0) {
            // console.log(this.action_detail)
            if (this.action_detail.bat !== undefined && this.action_detail.bat !== null) {
                console.log(this.action_detail.bat)
                switch (key) {
                    case "HardTag":
                        return this.action_detail.bat.HardTag
                    case "HitType":
                        return this.action_detail.bat.HitType
                    case "BuntTag":
                        return this.action_detail.bat.BuntTag
                    case "HitTag":
                        return this.action_detail.bat.HitTag

                    default:
                        return ""
                }
            }
            return ""
        }
        return ""
    }

    get_buntTag_arr() {
        console.log(this.action_code)
        switch (this.action_code) {
            case GAME_ACTIONLIST.IPS.S1B.CODE:
            case GAME_ACTIONLIST.IPS.S2B.CODE:
            case GAME_ACTIONLIST.IPS.S3B.CODE:
            case GAME_ACTIONLIST.IPS.HR.CODE:
            case GAME_ACTIONLIST.IPS.IHR.CODE:
            case GAME_ACTIONLIST.IPS.FOT.CODE:
            case GAME_ACTIONLIST.IPS.FC.CODE:
            case GAME_ACTIONLIST.IPS.DP_S.CODE:
            case GAME_ACTIONLIST.IPS.OBD.CODE:
            case GAME_ACTIONLIST.IPO.G.CODE:
            case GAME_ACTIONLIST.IPO.G_.CODE:
            case GAME_ACTIONLIST.IPO.GT.CODE:
            case GAME_ACTIONLIST.IPO.F.CODE:
            case GAME_ACTIONLIST.IPO.DP.CODE:
            case GAME_ACTIONLIST.IPO.TP.CODE:
            case GAME_ACTIONLIST.IPO.IF.CODE:
            case GAME_ACTIONLIST.IPO.INT.CODE:
            case GAME_ACTIONLIST.IPO.LO.CODE:
            case GAME_ACTIONLIST.IPO.OT_PO.CODE:
            case GAME_ACTIONLIST.IPO.UN_IO.CODE:
                return buntTag_arr1
            case GAME_ACTIONLIST.IPS.E_T.CODE:
            case GAME_ACTIONLIST.IPS.E_C.CODE:
            case GAME_ACTIONLIST.IPS.E_SF.CODE:
            case GAME_ACTIONLIST.IPO.SH.CODE:
            case GAME_ACTIONLIST.IPO.SF.CODE:
                return buntTag_arr2
            default:
                return []
        }
    }
}


export class RespAct {
    constructor({
        pitch,
        batter,
        runner
    }) {
        this.pitch = pitch
    }
    fromJson(jsonData) {
    }
}


function get_transcript_item(arr, str, items) {
    if (arr !== undefined && arr.length > 0) {
        var text = str + ":"
        var newArr = []
        arr.forEach(item => {
            newArr.push("(" + item.name + item.code + ")")
        })
        text += newArr.join(",")
        items.push(text)
    }
    return items
}


export class RespActionEditPitch {
    constructor({
        game_id,
        record_id,                  //動作成績id
        type,                 //投球結果 - 投球球種
        speedKM,                //投球結果 - 球速公里
        speedMI,                //投球結果 - 球速英里
        video_timestamp,

    }) {
        this.game_id = game_id
        this.record_id = record_id
        this.type = type
        this.speedKM = speedKM
        if (speedKM !== '') {
            this.speedMI = (parseInt(speedKM) * 0.621371192).toFixed(2)
        } else {
            this.speedMI = speedKM
        }
        this.video_timestamp = video_timestamp
    }

    fromJson(jsonData) {
        this.game_id = jsonData.game_id
        this.record_id = jsonData.record_id
        this.type = jsonData.type
        this.speedKM = jsonData.speedKM
        this.speedMI = jsonData.speedMI
        this.video_timestamp = jsonData.video_timestamp
    }
}

export class RespActionEditBat {
    constructor({
        game_id,
        record_id,                  //動作成績id
        HardTag,                 //擊球強度▼
        HitType,                //擊球種類▼
        BuntTag,                //觸擊標籤▼
        HitTag,                //安打標籤▼
        video_timestamp,

    }) {
        this.game_id = game_id
        this.record_id = record_id
        this.HardTag = HardTag
        this.HitType = HitType
        this.BuntTag = BuntTag
        this.HitTag = HitTag
        this.video_timestamp = video_timestamp
    }

    fromJson(jsonData) {
        this.game_id = jsonData.game_id
        this.record_id = jsonData.record_id
        this.HardTag = jsonData.HardTag
        this.HitType = jsonData.HitType
        this.BuntTag = jsonData.BuntTag
        this.HitTag = jsonData.HitTag
        this.video_timestamp = jsonData.video_timestamp
    }
}